import React from "react";
import { Link } from "react-router-dom";

const Page403 = () => (
  <div className="text-center">
    <div className="error mx-auto" data-text="403">
      403
    </div>
    <p className="lead text-gray-800 mb-5">Página ou recurso não permitido</p>
    <p className="text-gray-500 mb-0">
      Parece que página ou ao recurso que você estava tentando visualizar é proibido por algum motivo...
    </p>
    <Link to="/app/home">&larr; Voltar para o início</Link>
  </div>
);

export default Page403;
